// This file is automatically updated by bump-version.js
export const VERSION = '1.0.13';
